import { useEffect, useRef } from 'react'

import { SEARCH_INPUT_DEBOUNCE_MS } from './config'

/** Дебаунсирует вызов onSearch(value) на SEARCH_INPUT_DEBOUNCE_MS после последнего изменения value. */
export function useDebouncedSearch(value: string, onSearch?: (value: string) => void): void {
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    if (!onSearch) return undefined

    timerRef.current = setTimeout(() => onSearch(value), SEARCH_INPUT_DEBOUNCE_MS)

    return () => clearTimeout(timerRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
}
